import { SearchApiService } from '../../services/search-api.service';
import { SearchAnalyticsService } from '../../services/search-analytics.service';
import { SearchUtilsService } from '../../services/search-utils.service';

export default {
    namespaced: true,
    state: {
        suggestions: [],
        results: [],
        facts: [],
        totalNumberOfResults: 0,
        unfilteredNumberOfResults: 0,
        pageNumber: 0,
        pageTotalSize: 0,
        activeFilter: ""
    },
    mutations: {
        set_search_suggestions(state, suggestions) {
            state.suggestions = suggestions
        },
        set_clear_search_suggestions(state) {
            state.suggestions = []
        },
        set_search_results(state, results) {
            state.results = results
        },
        set_clear_search_results(state) {
            state.results = []
        },
        set_update_search_results(state, results) {
            state.results = SearchUtilsService.mergeSearchResults(state.results, results);
        },
        set_facts(state, facts) {
            state.facts = facts
        },
        set_clear_facts(state) {
            state.facts = []
        },
        set_total_number_of_results(state, totalNumberOfResults) {
            state.totalNumberOfResults = totalNumberOfResults
        },
        set_unfiltered_number_of_results(state, unfilteredNumberOfResults) {
            state.unfilteredNumberOfResults = unfilteredNumberOfResults
        },
        set_active_filter(state, filter) {
            state.activeFilter = filter
        },
        set_page_number(state, page) {
            state.pageNumber = page
        },
        set_page_total_size(state, page) {
            state.pageTotalSize = page
        },
        reset_search_state(state) {
            const resetState = SearchUtilsService.resetSearchState();
            Object.assign(state, resetState);
        }
    },
    actions: {
        async performSearchSuggestions(context, config) {
            try {
                const suggestions = await SearchApiService.fetchSuggestions(config.apiUrl, config.query);
                context.commit('set_search_suggestions', suggestions);
            } catch (error) {
                console.error('Failed to fetch suggestions:', error);
            }
        },
        clearSuggestions(context) {
            context.commit('set_clear_search_suggestions')
        },
        async performSearch(context, config) {
            try {
                const searchConfig = {
                    ...config,
                    activeFilter: context.state.activeFilter
                };

                const json = await SearchApiService.performSearch(searchConfig);

                SearchAnalyticsService.trackSearch(config.query, json.unfilteredNumberOfHits);

                if (config.page === 1) {
                    context.commit('set_search_results', json.hits);
                } else {
                    context.commit('set_update_search_results', json.hits);
                }

                context.commit('set_page_number', config.page);
                context.commit('set_page_total_size', json.pagingPagesTotal);
                context.commit('set_total_number_of_results', json.numberOfHits);
                context.commit('set_unfiltered_number_of_results', json.unfilteredNumberOfHits);
                context.commit('set_facts', json.sectionFacets);
            } catch (error) {
                console.error('Search failed:', error);
            }
        },
        clearResults(context) {
            context.commit('reset_search_state');
        },
        facts(context, config) {
            context.commit('set_facts', config.facts)
        },
        totalNumberOfResults(context, config) {
            context.commit('set_total_number_of_results', config.number)
        },
        activeFilter(context, config) {
            context.commit('set_active_filter', config.filter)
        },
        pageNumber(context, config) {
            context.commit('set_page_number', config.page)
        },
        pageTotalSize(context, config) {
            context.commit('set_page_total_size', config.page)
        }
    }
}